<template>
  <div class="main-container">
    <div class="emb" ref="embRef" v-if="list.length>1">
      <div class="emb_container">
        <div class="emb_slide" v-for="item in list" :key="item.id" @click.stop="handleLink(item.linkUrl)">
          <imgContainer :src="item.img" />
        </div>
      </div>
    </div>
    <div class="img-item" @click.stop="handleLink(linkUrl)">
      <imgContainer :src="imageUrl" />
    </div>
  </div>
</template>

<script setup>
import embCarousel from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay'
import {computed, onBeforeUnmount, defineProps, onMounted, ref, watch, nextTick} from "vue";
import imgContainer from '@/components/imgContainer/index.vue'

const embRef = ref(null)
const embApi = ref(null)
let prop = defineProps({
  list: {
    type: Array,
    default: () => [],
  }
})
const imageUrl = computed(function () {
  if (prop.list.length === 1) {
    return prop.list[0].img
  }
  return ""
})
const linkUrl = computed(function () {
  if (prop.list.length === 1) {
    return prop.list[0].linkUrl
  }
  return ""
})

const handleLink = (url) => {
  // 重新启动自动播放（解决点击后停止的问题）
  if (embApi.value && embApi.value.plugins().autoplay) {
    embApi.value.plugins().autoplay.play();
  }
  if (!url) return
  window.open(url, '_blank')
}
const initCarousel = () => {
  if (!embRef.value) return;
  // 销毁现有实例（如果存在）
  if (embApi.value && embApi.value.destroy) {
    embApi.value.destroy();
  }
  // 初始化时传入自动播放插件
  embApi.value = embCarousel(embRef.value, {
    loop: true,
    align: 'center',
    duration: 50,
    // v8版本中，自动播放选项直接放在主配置中
    autoplay: {
      delay: 1000,
      stopOnInteraction: false,
      stopOnClick: false
    }
  }, [Autoplay()])
};
watch(() => prop.list, (newVal) => {
  if (newVal.length > 1) {
    nextTick(() => {
      if (!embApi.value || !embApi.value.selectedScrollSnap) {
        initCarousel();
      }
    });
  }
});
// 销毁实例
onBeforeUnmount(() => {
  embApi.value?.destroy()
})
</script>

<style scoped lang="scss">
.main-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.emb {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.img-item {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.img-item-specific {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.emb_container {
  display: flex;
  width: 100%;
  height: 100%;
}

.emb_slide {
  flex: 0 0 100%;
  min-width: 0;
  position: relative;
  cursor: pointer;
}

.emb_slide_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
